import * as React from 'react';
import { useSelector } from 'react-redux';

import { StateType } from '../../reducers';
import { addModifiers } from '../../shared/helpers';

import './PerformanceTable.scss';

interface PerformanceTableProps {
  path: string[];
}

const PerformanceTable = (props: PerformanceTableProps) => {
  // @ts-ignore
  const tableHeader: any = useSelector((state: StateType) => state.getIn(props.path.concat(['tableHeader'])));
  // @ts-ignore
  const tableData: any = useSelector((state: StateType) => state.getIn(props.path.concat(['tableData'])));

  return (
    <div className="performance-table">
      <table cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            {tableHeader &&
              tableHeader.map((header: any, index: number) => (
                <React.Fragment key={`${header.get('title')}-${index}`}>
                  <th colSpan={header.get('columnWidth')}>{header.get('title')}</th>
                  {tableHeader.size - 1 !== index && <th />}
                </React.Fragment>
              ))}
          </tr>
        </thead>
        <tbody>
          {tableData &&
            tableData.map((row: any, index: number) => (
              <tr key={index}>
                {row.map((element: any, key: number) => (
                  <React.Fragment key={`${index}-${key}`}>
                    {element.get('value') !== undefined && (
                      <td className={tableHeader.getIn([key, 'class'])}>
                        {`${element.get('value')}${
                          tableHeader.getIn([key, 'type']) === 'percent'
                            ? ' %'
                            : tableHeader.getIn([key, 'type']) === 'permyriad'
                            ? ' ‱'
                            : ''
                        }`}
                      </td>
                    )}
                    {element.get('change') !== undefined && (
                      <td className={addModifiers(tableHeader.getIn([key, 'class']), [element.get('change'), 'icon'])} />
                    )}
                    {element.get('difference') !== undefined && (
                      <td className={addModifiers(tableHeader.getIn([key, 'class']), [element.get('change')])}>
                        {element.get('difference')}
                      </td>
                    )}
                    {row.size - 1 !== key && <td />}
                  </React.Fragment>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default PerformanceTable;
